import { AppSettings } from './appSettings'

declare global {
  interface Window {
    appSettings: AppSettings
  }
}

export const { appSettings } = window
